import FlexPane from './_flex-pane.js'
import Button from './_button.js'
import RotatableImage from './_rotatable-image.js'
import Text from './_text.js'
import EventListMarketsSection from './_event-list-markets-section.js'
import HideablePane from './_hideable-pane.js'
import EarlyPayoutIndicator from './_early-payout-indicator.js'
import EarlyPayoutOffers from './_early-payout-offers.js'

export default {
  name: 'EventListGroup',
  values: {
    expandable: true,
    showOffersAboveHeader: false,
    showHeaderLabels: true,
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    headerButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            justifyContent: 'flex-end',
            padding: '0 8px',
            _desktop_minHeight: '40px',
            _mobile_minHeight: '34px',
          },
        },
      },
    },
    headerInfoContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          _mobile_height: '50px',
        },
      },
    },
    rotation: {
      configSet: RotatableImage,
      configValues: {
        image: {
          src: 'chevron-up',
          style: {
            minWidth: '8px',
            minHeight: '8px',
          },
        },
      },
    },
    headerTypeAndClassContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        _mobile_itemSpacing: '0px',
        style: {
          _mobile_flexDirection: 'column',
          _mobile_justifyContent: 'center',
        },
      },
    },
    showDuoLineHeader: false,
    _mobile_showDuoLineHeader: true,
    headerPrimaryLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          alignItems: 'center',
          flexGrow: 0,
        },
      },
    },
    headerSecondaryLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          alignItems: 'center',
          flexGrow: 0,
        },
      },
    },
    headerSegmentsContainer: {
      configSet: EventListMarketsSection,
      configValues: {
        container: {
          style: {
            flexShrink: 0,
            flexGrow: 0,
          },
        },
      },
    },
    headerSegment: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexBasis: '100%',
        },
      },
    },
    headerSegmentLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexBasis: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        style: {
          textAlign: 'center',
        },
      },
    },
    contentHideablePane: {
      configSet: HideablePane,
      configValues: {
        style: {
          base: {
            padding: '0 8px',
          },
          innerContainer: {
            flexDirection: 'column',
          },
        },
      },
    },
    offersText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    offersContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          alignItems: 'center',
          flexGrow: '1',
          flexShrink: '0',
          padding: '0',
        },
      },
    },
    earlyPayoutIndicator: {
      configSet: EarlyPayoutIndicator,
      configValues: {},
    },
    earlyPayoutOffers: {
      configSet: EarlyPayoutOffers,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
